import { LandingPagesEffects } from './landing-pages.effect';

export const effects = [LandingPagesEffects];
export * from './landing-pages.effect';
